/**
 * 签名工具模块
 * 支持动态加载 xt-sign CDN 脚本
 */

/** CDN 地址 */
import { signPlusByMd5 } from './xt-sign.min.js'

/**
 * 签名配置选项
 */
export interface SignOptions {
  /** 账号秘钥，默认使用内置值 */
  secret?: string
  /** 要访问的接口完整地址 */
  url: string
  /** 调试模式，默认 true */
  debug?: boolean
  /** 需要删除的字段值，默认 [null, undefined] */
  excludeValues?: unknown[]
}

/**
 * 获取签名头信息
 * @param data 请求数据
 * @param options 签名选项
 * @returns 签名头对象
 */
export function getSignHeaders(
  data: Record<string, unknown>,
  options: SignOptions
): Record<string, string> {

  const { url, debug = false, excludeValues } = options

  try {
    return signPlusByMd5(data, {
      url,
      debug,
      excludeValues,
    })
  } catch (error) {
    console.warn('[Tracker Sign] Sign failed:', error)
    return {}
  }
}
